import React, { useState } from 'react';
import {
	makeStyles,
	Button,
	Box,
	InputAdornment,
	Tabs,
	Tab,
	withStyles,
	FormControlLabel,
	Checkbox,
	Divider,
	Grid,
	MenuItem,
	Radio,
	TextField as TextField2,
} from '@material-ui/core';
import TitleText from '../components/reusableComponents/TitleText';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import { setPayment } from '../reducers/UiReducer';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
	FlightBookEtravDispatch,
	FlightBookDispatch,
	FlightTicketLCCDispatch,
} from '../reducers/HomeReducer';
import ErrorModal from '../components/reusableComponents/ErrorModal';
const title = ['Mr', 'Mrs'];
const useStyles = makeStyles((theme) => ({
	selectField: {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: '1px solid #959595',
			},
		},
		backgroundColor: 'white',
		marginBottom: 30,
		width: '100%',
		marginTop: 10,
		borderRadius: 5,
		[theme.breakpoints.down('xs')]: {
			marginBottom: 15,
			marginTop: 8,
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
		},
		'& .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root': {
			borderRadius: 5,
		},
	},
	InputPropsStyle: {
		backgroundColor: 'white',
		borderRadius: 5,
	},
	inputPropsStyle: {
		padding: 14,
	},
	createButton: {
		backgroundColor: 'rgb(239, 51, 57)',
		color: 'white',
		borderRadius: 5,
		width: '100%',
		padding: '11px 8px',
		'&:hover': {
			backgroundColor: 'rgb(239, 51, 57)',
		},
	},
	tabBorder: {
		borderBottom: '2px solid transparent',
		color: '#7B95AB',
		fontWeight: 400,
	},
	tabBorderColor: {
		borderBottom: '2px solid #313131',
		color: '#00325B',
		fontWeight: 700,
	},
	tab: {
		[theme.breakpoints.up('sm')]: {
			'& .MuiTab-root': {
				minWidth: 241,
				fontSize: 22,
			},
		},
	},
	date: {
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
			width: '100%',
		},
	},
	dob: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	passport: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	root: {
		'& .MuiFormHelperText-root': {
			fontSize: 12,
		},
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
			fontSize: 14,
		},
	},
	root2: {
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
			fontSize: 14,
		},
	},
}));
const FlightConfirmForm = () => {
	const classes = useStyles();
	const location = useLocation();
	const history = useHistory();
	const dispatch = useDispatch();
	const [hold, setHold] = useState(false);
	const [pay, setPay] = useState(false);
	const { agentlogin } = useSelector((state) => state.user);
	const { payment } = useSelector((state) => state.ui);
	const { fareQuoteEtrav } = useSelector((state) => state.home);
	const [offline, setOffline] = useState(false);
	const handlePayment = (response) => {
		alert(response.razorpay_payment_id);
		console.log(response);
		if (location.state.OneflightData.Airline_Code) {
			if (location.state.body.AdultCount === 1) {
				let formEtrav = {
					Customer_Mobile: location.state.formData.phone,
					Passenger_Mobile: location.state.formData.phone,
					WhatsAPP_Mobile: null,
					Passenger_Email: location.state.formData
						? location.state.formData.email
						: '',
					PAX_Details: [
						{
							Pax_Id: 1,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA1
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA1
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA1
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
					],

					GST: true,
					GST_Number: '29AADCB2230M1ZP',
					GST_HolderName: 'GST Holder Name',
					GST_Address: 'GST Address',
					BookingFlightDetails: [
						{
							Search_Key: location.state.IDEtrav,
							Flight_Key:
								fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Flight_Key,
							BookingSSRDetails: [
								// {
								// 	Pax_Id: 1,
								// 	SSR_Key:
								// 		'J3jtb85GjGmacPZ2KMq/Fll/JXc2WYpskCI9V0e2/jB19YJkhMxC1Dhl/ro+ac6idc7PcljHd3MDHuvX9XpXxtI+oudpOafRt3vvStGYZUzOQP35YeRQ4Bp9WdjvOgc6MnoX5mTO2vzQomWg0vC23mrMfesLhEuWvbhenHCGmvOJwmTR1lk5a7Y+smMcX+CE7FignZsxNd01ReKIT+ebuwnx7/8GH/eYjvGrQWLkWU53zbtPbvWpcRY8ZAfpVO0/SbD5+S5Ra0x6Fe3vFloe8tWIiCMoKwI6wOLtBQmmY5E2F3DrSgtFPETgLgp2v+rU',
								// },
								// {
								// 	Pax_Id: 1,
								// 	SSR_Key:
								// 		'BtyQS0cDFeFO19V32F7Xp16vSYN928ncYPXDMvoFEzy8oYSf1+W4Ygo7Vnq2csxVHi9RoESmpAPRU7wqtqOKYq51YfeQJT7E7pleplo0sZmDOWcX+GX+003qHfnYOH1uLt5spc86Qbb7EVvzEipqCr+RSH/AGG/Zwyhym04mlZWWssSFPw2IfHdauLKYkN7NvrGpkztx7XyG//8cgvJkhaMh8Vh4vJllw16N2TESjYyrnBNaEwmgcNFTrFl/BYHKVFFWT3hSzfhbFHSRVEV90op50n0y+0aC2Op8H57xrHEm0Yq6dGv/yVPj4RH8Bnpt8u/jfi+aCLLKlcsKSg1fFtnUURH9JJE3AZEOrmefYUYM+NVZRvprhDJqcs3QqinWxeaG9KjFhbnDw5sTSxvsHI9N4VAGEC8jtJeygtxRgVL0l+01ggySkRukfTqQmJSfX7Ru4pvtCgIuOz8JSPS4pgJNvNfiCUgX001z/9mC71A=',
								// },
							],
						},
					],
					CostCenterId: 0,
					ProjectId: 0,
					BookingRemark: 'BOM-MAA  29-Mar-2021  Test API With GST',
					CorporateStatus: 0,
					CorporatePaymentMode: 0,
					MissedSavingReason: null,
					CorpTripType: null,
					CorpTripSubType: null,
					TripRequestId: null,
					BookingAlertIds: null,
				};
				console.log('formEtrav', formEtrav);
				dispatch(
					FlightBookEtravDispatch(formEtrav, history, payment, location.state)
				);
			} else if (location.state.body.AdultCount === 2) {
				let formEtrav = {
					Customer_Mobile: location.state.formData.phone,
					Passenger_Mobile: location.state.formData.phone,
					WhatsAPP_Mobile: null,
					Passenger_Email: location.state.formData
						? location.state.formData.email
						: '',
					PAX_Details: [
						{
							Pax_Id: 1,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA1
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA1
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA1
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
						{
							Pax_Id: 2,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA2
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA2
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA2
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
					],

					GST: true,
					GST_Number: '29AADCB2230M1ZP',
					GST_HolderName: 'GST Holder Name',
					GST_Address: 'GST Address',
					BookingFlightDetails: [
						{
							Search_Key: location.state.IDEtrav,
							Flight_Key:
								fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Flight_Key,
							BookingSSRDetails: [
								// {
								// 	Pax_Id: 1,
								// 	SSR_Key:
								// 		'J3jtb85GjGmacPZ2KMq/Fll/JXc2WYpskCI9V0e2/jB19YJkhMxC1Dhl/ro+ac6idc7PcljHd3MDHuvX9XpXxtI+oudpOafRt3vvStGYZUzOQP35YeRQ4Bp9WdjvOgc6MnoX5mTO2vzQomWg0vC23mrMfesLhEuWvbhenHCGmvOJwmTR1lk5a7Y+smMcX+CE7FignZsxNd01ReKIT+ebuwnx7/8GH/eYjvGrQWLkWU53zbtPbvWpcRY8ZAfpVO0/SbD5+S5Ra0x6Fe3vFloe8tWIiCMoKwI6wOLtBQmmY5E2F3DrSgtFPETgLgp2v+rU',
								// },
								// {
								// 	Pax_Id: 1,
								// 	SSR_Key:
								// 		'BtyQS0cDFeFO19V32F7Xp16vSYN928ncYPXDMvoFEzy8oYSf1+W4Ygo7Vnq2csxVHi9RoESmpAPRU7wqtqOKYq51YfeQJT7E7pleplo0sZmDOWcX+GX+003qHfnYOH1uLt5spc86Qbb7EVvzEipqCr+RSH/AGG/Zwyhym04mlZWWssSFPw2IfHdauLKYkN7NvrGpkztx7XyG//8cgvJkhaMh8Vh4vJllw16N2TESjYyrnBNaEwmgcNFTrFl/BYHKVFFWT3hSzfhbFHSRVEV90op50n0y+0aC2Op8H57xrHEm0Yq6dGv/yVPj4RH8Bnpt8u/jfi+aCLLKlcsKSg1fFtnUURH9JJE3AZEOrmefYUYM+NVZRvprhDJqcs3QqinWxeaG9KjFhbnDw5sTSxvsHI9N4VAGEC8jtJeygtxRgVL0l+01ggySkRukfTqQmJSfX7Ru4pvtCgIuOz8JSPS4pgJNvNfiCUgX001z/9mC71A=',
								// },
							],
						},
					],
					CostCenterId: 0,
					ProjectId: 0,
					BookingRemark: 'BOM-MAA  29-Mar-2021  Test API With GST',
					CorporateStatus: 0,
					CorporatePaymentMode: 0,
					MissedSavingReason: null,
					CorpTripType: null,
					CorpTripSubType: null,
					TripRequestId: null,
					BookingAlertIds: null,
				};
				console.log('formEtrav', formEtrav);
				dispatch(FlightBookEtravDispatch(formEtrav, history, payment));
			} else if (location.state.body.AdultCount === 3) {
				let formEtrav = {
					Customer_Mobile: location.state.formData.phone,
					Passenger_Mobile: location.state.formData.phone,
					WhatsAPP_Mobile: null,
					Passenger_Email: location.state.formData
						? location.state.formData.email
						: '',
					PAX_Details: [
						{
							Pax_Id: 1,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA1
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA1
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA1
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
						{
							Pax_Id: 2,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA2
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA2
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA2
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
						{
							Pax_Id: 3,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA3
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA3
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA3
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
					],

					GST: true,
					GST_Number: '29AADCB2230M1ZP',
					GST_HolderName: 'GST Holder Name',
					GST_Address: 'GST Address',
					BookingFlightDetails: [
						{
							Search_Key: location.state.IDEtrav,
							Flight_Key:
								fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Flight_Key,
							BookingSSRDetails: [
								// {
								// 	Pax_Id: 1,
								// 	SSR_Key:
								// 		'J3jtb85GjGmacPZ2KMq/Fll/JXc2WYpskCI9V0e2/jB19YJkhMxC1Dhl/ro+ac6idc7PcljHd3MDHuvX9XpXxtI+oudpOafRt3vvStGYZUzOQP35YeRQ4Bp9WdjvOgc6MnoX5mTO2vzQomWg0vC23mrMfesLhEuWvbhenHCGmvOJwmTR1lk5a7Y+smMcX+CE7FignZsxNd01ReKIT+ebuwnx7/8GH/eYjvGrQWLkWU53zbtPbvWpcRY8ZAfpVO0/SbD5+S5Ra0x6Fe3vFloe8tWIiCMoKwI6wOLtBQmmY5E2F3DrSgtFPETgLgp2v+rU',
								// },
								// {
								// 	Pax_Id: 1,
								// 	SSR_Key:
								// 		'BtyQS0cDFeFO19V32F7Xp16vSYN928ncYPXDMvoFEzy8oYSf1+W4Ygo7Vnq2csxVHi9RoESmpAPRU7wqtqOKYq51YfeQJT7E7pleplo0sZmDOWcX+GX+003qHfnYOH1uLt5spc86Qbb7EVvzEipqCr+RSH/AGG/Zwyhym04mlZWWssSFPw2IfHdauLKYkN7NvrGpkztx7XyG//8cgvJkhaMh8Vh4vJllw16N2TESjYyrnBNaEwmgcNFTrFl/BYHKVFFWT3hSzfhbFHSRVEV90op50n0y+0aC2Op8H57xrHEm0Yq6dGv/yVPj4RH8Bnpt8u/jfi+aCLLKlcsKSg1fFtnUURH9JJE3AZEOrmefYUYM+NVZRvprhDJqcs3QqinWxeaG9KjFhbnDw5sTSxvsHI9N4VAGEC8jtJeygtxRgVL0l+01ggySkRukfTqQmJSfX7Ru4pvtCgIuOz8JSPS4pgJNvNfiCUgX001z/9mC71A=',
								// },
							],
						},
					],
					CostCenterId: 0,
					ProjectId: 0,
					BookingRemark: 'BOM-MAA  29-Mar-2021  Test API With GST',
					CorporateStatus: 0,
					CorporatePaymentMode: 0,
					MissedSavingReason: null,
					CorpTripType: null,
					CorpTripSubType: null,
					TripRequestId: null,
					BookingAlertIds: null,
				};
				console.log('formEtrav', formEtrav);
				dispatch(FlightBookEtravDispatch(formEtrav, history, payment));
			} else if (location.state.body.AdultCount === 4) {
				let formEtrav = {
					Customer_Mobile: location.state.formData.phone,
					Passenger_Mobile: location.state.formData.phone,
					WhatsAPP_Mobile: null,
					Passenger_Email: location.state.formData
						? location.state.formData.email
						: '',
					PAX_Details: [
						{
							Pax_Id: 1,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA1
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA1
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA1
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
						{
							Pax_Id: 2,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA2
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA2
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA2
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
						{
							Pax_Id: 3,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA3
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA3
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA3
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
						{
							Pax_Id: 4,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA4
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA4
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA4
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
					],

					GST: true,
					GST_Number: '29AADCB2230M1ZP',
					GST_HolderName: 'GST Holder Name',
					GST_Address: 'GST Address',
					BookingFlightDetails: [
						{
							Search_Key: location.state.IDEtrav,
							Flight_Key:
								fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Flight_Key,
							BookingSSRDetails: [
								// {
								// 	Pax_Id: 1,
								// 	SSR_Key:
								// 		'J3jtb85GjGmacPZ2KMq/Fll/JXc2WYpskCI9V0e2/jB19YJkhMxC1Dhl/ro+ac6idc7PcljHd3MDHuvX9XpXxtI+oudpOafRt3vvStGYZUzOQP35YeRQ4Bp9WdjvOgc6MnoX5mTO2vzQomWg0vC23mrMfesLhEuWvbhenHCGmvOJwmTR1lk5a7Y+smMcX+CE7FignZsxNd01ReKIT+ebuwnx7/8GH/eYjvGrQWLkWU53zbtPbvWpcRY8ZAfpVO0/SbD5+S5Ra0x6Fe3vFloe8tWIiCMoKwI6wOLtBQmmY5E2F3DrSgtFPETgLgp2v+rU',
								// },
								// {
								// 	Pax_Id: 1,
								// 	SSR_Key:
								// 		'BtyQS0cDFeFO19V32F7Xp16vSYN928ncYPXDMvoFEzy8oYSf1+W4Ygo7Vnq2csxVHi9RoESmpAPRU7wqtqOKYq51YfeQJT7E7pleplo0sZmDOWcX+GX+003qHfnYOH1uLt5spc86Qbb7EVvzEipqCr+RSH/AGG/Zwyhym04mlZWWssSFPw2IfHdauLKYkN7NvrGpkztx7XyG//8cgvJkhaMh8Vh4vJllw16N2TESjYyrnBNaEwmgcNFTrFl/BYHKVFFWT3hSzfhbFHSRVEV90op50n0y+0aC2Op8H57xrHEm0Yq6dGv/yVPj4RH8Bnpt8u/jfi+aCLLKlcsKSg1fFtnUURH9JJE3AZEOrmefYUYM+NVZRvprhDJqcs3QqinWxeaG9KjFhbnDw5sTSxvsHI9N4VAGEC8jtJeygtxRgVL0l+01ggySkRukfTqQmJSfX7Ru4pvtCgIuOz8JSPS4pgJNvNfiCUgX001z/9mC71A=',
								// },
							],
						},
					],
					CostCenterId: 0,
					ProjectId: 0,
					BookingRemark: 'BOM-MAA  29-Mar-2021  Test API With GST',
					CorporateStatus: 0,
					CorporatePaymentMode: 0,
					MissedSavingReason: null,
					CorpTripType: null,
					CorpTripSubType: null,
					TripRequestId: null,
					BookingAlertIds: null,
				};
				console.log('formEtrav', formEtrav);
				dispatch(FlightBookEtravDispatch(formEtrav, history, payment));
			} else if (location.state.body.AdultCount === 5) {
				let formEtrav = {
					Customer_Mobile: location.state.formData.phone,
					Passenger_Mobile: location.state.formData.phone,
					WhatsAPP_Mobile: null,
					Passenger_Email: location.state.formData
						? location.state.formData.email
						: '',
					PAX_Details: [
						{
							Pax_Id: 1,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA1
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA1
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA1
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
						{
							Pax_Id: 2,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA2
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA2
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA2
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
						{
							Pax_Id: 3,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA3
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA3
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA3
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
						{
							Pax_Id: 4,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA4
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA4
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA4
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
						{
							Pax_Id: 5,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA5
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA5
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA5
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
					],

					GST: true,
					GST_Number: '29AADCB2230M1ZP',
					GST_HolderName: 'GST Holder Name',
					GST_Address: 'GST Address',
					BookingFlightDetails: [
						{
							Search_Key: location.state.IDEtrav,
							Flight_Key:
								fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Flight_Key,
							BookingSSRDetails: [
								// {
								// 	Pax_Id: 1,
								// 	SSR_Key:
								// 		'J3jtb85GjGmacPZ2KMq/Fll/JXc2WYpskCI9V0e2/jB19YJkhMxC1Dhl/ro+ac6idc7PcljHd3MDHuvX9XpXxtI+oudpOafRt3vvStGYZUzOQP35YeRQ4Bp9WdjvOgc6MnoX5mTO2vzQomWg0vC23mrMfesLhEuWvbhenHCGmvOJwmTR1lk5a7Y+smMcX+CE7FignZsxNd01ReKIT+ebuwnx7/8GH/eYjvGrQWLkWU53zbtPbvWpcRY8ZAfpVO0/SbD5+S5Ra0x6Fe3vFloe8tWIiCMoKwI6wOLtBQmmY5E2F3DrSgtFPETgLgp2v+rU',
								// },
								// {
								// 	Pax_Id: 1,
								// 	SSR_Key:
								// 		'BtyQS0cDFeFO19V32F7Xp16vSYN928ncYPXDMvoFEzy8oYSf1+W4Ygo7Vnq2csxVHi9RoESmpAPRU7wqtqOKYq51YfeQJT7E7pleplo0sZmDOWcX+GX+003qHfnYOH1uLt5spc86Qbb7EVvzEipqCr+RSH/AGG/Zwyhym04mlZWWssSFPw2IfHdauLKYkN7NvrGpkztx7XyG//8cgvJkhaMh8Vh4vJllw16N2TESjYyrnBNaEwmgcNFTrFl/BYHKVFFWT3hSzfhbFHSRVEV90op50n0y+0aC2Op8H57xrHEm0Yq6dGv/yVPj4RH8Bnpt8u/jfi+aCLLKlcsKSg1fFtnUURH9JJE3AZEOrmefYUYM+NVZRvprhDJqcs3QqinWxeaG9KjFhbnDw5sTSxvsHI9N4VAGEC8jtJeygtxRgVL0l+01ggySkRukfTqQmJSfX7Ru4pvtCgIuOz8JSPS4pgJNvNfiCUgX001z/9mC71A=',
								// },
							],
						},
					],
					CostCenterId: 0,
					ProjectId: 0,
					BookingRemark: 'BOM-MAA  29-Mar-2021  Test API With GST',
					CorporateStatus: 0,
					CorporatePaymentMode: 0,
					MissedSavingReason: null,
					CorpTripType: null,
					CorpTripSubType: null,
					TripRequestId: null,
					BookingAlertIds: null,
				};
				console.log('formEtrav', formEtrav);
				dispatch(FlightBookEtravDispatch(formEtrav, history, payment));
			} else if (location.state.body.AdultCount === 6) {
				let formEtrav = {
					Customer_Mobile: location.state.formData.phone,
					Passenger_Mobile: location.state.formData.phone,
					WhatsAPP_Mobile: null,
					Passenger_Email: location.state.formData
						? location.state.formData.email
						: '',
					PAX_Details: [
						{
							Pax_Id: 1,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA1
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA1
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA1
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
						{
							Pax_Id: 2,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA2
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA2
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA2
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
						{
							Pax_Id: 3,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA3
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA3
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA3
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
						{
							Pax_Id: 4,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA4
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA4
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA4
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
						{
							Pax_Id: 5,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA5
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA5
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA5
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
						{
							Pax_Id: 6,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.titleA6
								: '',
							First_Name: location.state.formData
								? location.state.formData.first_nameA6
								: '',
							Last_Name: location.state.formData
								? location.state.formData.last_nameA6
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
					],

					GST: true,
					GST_Number: '29AADCB2230M1ZP',
					GST_HolderName: 'GST Holder Name',
					GST_Address: 'GST Address',
					BookingFlightDetails: [
						{
							Search_Key: location.state.IDEtrav,
							Flight_Key:
								fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Flight_Key,
							BookingSSRDetails: [
								// {
								// 	Pax_Id: 1,
								// 	SSR_Key:
								// 		'J3jtb85GjGmacPZ2KMq/Fll/JXc2WYpskCI9V0e2/jB19YJkhMxC1Dhl/ro+ac6idc7PcljHd3MDHuvX9XpXxtI+oudpOafRt3vvStGYZUzOQP35YeRQ4Bp9WdjvOgc6MnoX5mTO2vzQomWg0vC23mrMfesLhEuWvbhenHCGmvOJwmTR1lk5a7Y+smMcX+CE7FignZsxNd01ReKIT+ebuwnx7/8GH/eYjvGrQWLkWU53zbtPbvWpcRY8ZAfpVO0/SbD5+S5Ra0x6Fe3vFloe8tWIiCMoKwI6wOLtBQmmY5E2F3DrSgtFPETgLgp2v+rU',
								// },
								// {
								// 	Pax_Id: 1,
								// 	SSR_Key:
								// 		'BtyQS0cDFeFO19V32F7Xp16vSYN928ncYPXDMvoFEzy8oYSf1+W4Ygo7Vnq2csxVHi9RoESmpAPRU7wqtqOKYq51YfeQJT7E7pleplo0sZmDOWcX+GX+003qHfnYOH1uLt5spc86Qbb7EVvzEipqCr+RSH/AGG/Zwyhym04mlZWWssSFPw2IfHdauLKYkN7NvrGpkztx7XyG//8cgvJkhaMh8Vh4vJllw16N2TESjYyrnBNaEwmgcNFTrFl/BYHKVFFWT3hSzfhbFHSRVEV90op50n0y+0aC2Op8H57xrHEm0Yq6dGv/yVPj4RH8Bnpt8u/jfi+aCLLKlcsKSg1fFtnUURH9JJE3AZEOrmefYUYM+NVZRvprhDJqcs3QqinWxeaG9KjFhbnDw5sTSxvsHI9N4VAGEC8jtJeygtxRgVL0l+01ggySkRukfTqQmJSfX7Ru4pvtCgIuOz8JSPS4pgJNvNfiCUgX001z/9mC71A=',
								// },
							],
						},
					],
					CostCenterId: 0,
					ProjectId: 0,
					BookingRemark: 'BOM-MAA  29-Mar-2021  Test API With GST',
					CorporateStatus: 0,
					CorporatePaymentMode: 0,
					MissedSavingReason: null,
					CorpTripType: null,
					CorpTripSubType: null,
					TripRequestId: null,
					BookingAlertIds: null,
				};
				console.log('formEtrav', formEtrav);
				dispatch(FlightBookEtravDispatch(formEtrav, history, payment));
			}
		} else if (location.state.OneflightData.IsLCC) {
			console.log('LCC Pro');
			if (location.state.body.AdultCount === 1) {
				let formDataLCC = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.OneflightData.ResultIndex,
					Passengers: [
						{
							Title: location.state.formData
								? location.state.formData.titleA1
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA1
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA1
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: 'hello',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: 'abc',
							GSTCompanyContactNumber: '4564345434',
							GSTCompanyName: 'fffgde',
							GSTNumber: '37AADCS0472N1Z1',
							GSTCompanyEmail: 'fg@gmail.com',
						},
					],
					Baggage: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Baggage',
							Description: 2,
							Weight: 0,
							Currency: 'INR',
							Price: 5000,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					MealDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Meal',
							Description: 2,
							AirlineDescription: '',
							Quantity: 1,
							Currency: 'INR',
							Price: 300,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					SeatDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							CraftType: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Craft;
										})
								: '',
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
							AvailablityType: 1,
							Description: 2,
							Code: '2A',
							RowNo: '2',
							SeatNo: 'A',
							SeatType: 1,
							SeatWayType: 2,
							Compartment: 1,
							Deck: 1,
							Currency: 'INR',
							Price: 300,
						},
					],
				};
				console.log('Lcc', formDataLCC);
				dispatch(FlightTicketLCCDispatch(formDataLCC, history));
			} else if (location.state.body.AdultCount === 2) {
				let formDataLCC = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.OneflightData.ResultIndex,
					Passengers: [
						{
							Title: location.state.formData
								? location.state.formData.titleA1
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA1
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA1
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: 'hello',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: 'abc',
							GSTCompanyContactNumber: '4564345434',
							GSTCompanyName: 'fffgde',
							GSTNumber: '37AADCS0472N1Z1',
							GSTCompanyEmail: 'fg@gmail.com',
						},
						{
							Title: location.state.formData
								? location.state.formData.titleA2
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA2
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA2
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: 'hello',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: 'abc',
							GSTCompanyContactNumber: '4564345434',
							GSTCompanyName: 'fffgde',
							GSTNumber: '37AADCS0472N1Z1',
							GSTCompanyEmail: 'fg@gmail.com',
						},
					],
					Baggage: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Baggage',
							Description: 2,
							Weight: 0,
							Currency: 'INR',
							Price: 5000,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					MealDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Meal',
							Description: 2,
							AirlineDescription: '',
							Quantity: 1,
							Currency: 'INR',
							Price: 300,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					SeatDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							CraftType: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Craft;
										})
								: '',
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
							AvailablityType: 1,
							Description: 2,
							Code: '2A',
							RowNo: '2',
							SeatNo: 'A',
							SeatType: 1,
							SeatWayType: 2,
							Compartment: 1,
							Deck: 1,
							Currency: 'INR',
							Price: 300,
						},
					],
				};
				console.log('Lcc', formDataLCC);
				dispatch(FlightTicketLCCDispatch(formDataLCC, history));
			} else if (location.state.body.AdultCount === 3) {
				let formDataLCC = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.OneflightData.ResultIndex,
					Passengers: [
						{
							Title: location.state.formData
								? location.state.formData.titleA1
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA1
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA1
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: 'hello',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: 'abc',
							GSTCompanyContactNumber: '4564345434',
							GSTCompanyName: 'fffgde',
							GSTNumber: '37AADCS0472N1Z1',
							GSTCompanyEmail: 'fg@gmail.com',
						},
						{
							Title: location.state.formData
								? location.state.formData.titleA2
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA2
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA2
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: 'hello',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: 'abc',
							GSTCompanyContactNumber: '4564345434',
							GSTCompanyName: 'fffgde',
							GSTNumber: '37AADCS0472N1Z1',
							GSTCompanyEmail: 'fg@gmail.com',
						},
						{
							Title: location.state.formData
								? location.state.formData.titleA3
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA3
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA3
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: 'hello',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: 'abc',
							GSTCompanyContactNumber: '4564345434',
							GSTCompanyName: 'fffgde',
							GSTNumber: '37AADCS0472N1Z1',
							GSTCompanyEmail: 'fg@gmail.com',
						},
					],
					Baggage: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Baggage',
							Description: 2,
							Weight: 0,
							Currency: 'INR',
							Price: 5000,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					MealDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Meal',
							Description: 2,
							AirlineDescription: '',
							Quantity: 1,
							Currency: 'INR',
							Price: 300,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					SeatDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							CraftType: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Craft;
										})
								: '',
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
							AvailablityType: 1,
							Description: 2,
							Code: '2A',
							RowNo: '2',
							SeatNo: 'A',
							SeatType: 1,
							SeatWayType: 2,
							Compartment: 1,
							Deck: 1,
							Currency: 'INR',
							Price: 300,
						},
					],
				};
				console.log('Lcc', formDataLCC);
				dispatch(FlightTicketLCCDispatch(formDataLCC, history));
			} else if (location.state.body.AdultCount === 4) {
				let formDataLCC = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.OneflightData.ResultIndex,
					Passengers: [
						{
							Title: location.state.formData
								? location.state.formData.titleA1
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA1
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA1
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: 'hello',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: 'abc',
							GSTCompanyContactNumber: '4564345434',
							GSTCompanyName: 'fffgde',
							GSTNumber: '37AADCS0472N1Z1',
							GSTCompanyEmail: 'fg@gmail.com',
						},
						{
							Title: location.state.formData
								? location.state.formData.titleA2
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA2
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA2
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: 'hello',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: 'abc',
							GSTCompanyContactNumber: '4564345434',
							GSTCompanyName: 'fffgde',
							GSTNumber: '37AADCS0472N1Z1',
							GSTCompanyEmail: 'fg@gmail.com',
						},
						{
							Title: location.state.formData
								? location.state.formData.titleA3
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA3
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA3
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: 'hello',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: 'abc',
							GSTCompanyContactNumber: '4564345434',
							GSTCompanyName: 'fffgde',
							GSTNumber: '37AADCS0472N1Z1',
							GSTCompanyEmail: 'fg@gmail.com',
						},
						{
							Title: location.state.formData
								? location.state.formData.titleA4
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA4
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA4
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: 'hello',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: 'abc',
							GSTCompanyContactNumber: '4564345434',
							GSTCompanyName: 'fffgde',
							GSTNumber: '37AADCS0472N1Z1',
							GSTCompanyEmail: 'fg@gmail.com',
						},
					],
					Baggage: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Baggage',
							Description: 2,
							Weight: 0,
							Currency: 'INR',
							Price: 5000,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					MealDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Meal',
							Description: 2,
							AirlineDescription: '',
							Quantity: 1,
							Currency: 'INR',
							Price: 300,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					SeatDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							CraftType: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Craft;
										})
								: '',
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
							AvailablityType: 1,
							Description: 2,
							Code: '2A',
							RowNo: '2',
							SeatNo: 'A',
							SeatType: 1,
							SeatWayType: 2,
							Compartment: 1,
							Deck: 1,
							Currency: 'INR',
							Price: 300,
						},
					],
				};
				console.log('Lcc', formDataLCC);
				dispatch(FlightTicketLCCDispatch(formDataLCC, history));
			}
		} else {
			if (location.state.body.AdultCount === 1) {
				let formData = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.OneflightData.ResultIndex,
					Passengers: [
						{
							Title: location.state.formData
								? location.state.formData.titleA1
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA1
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA1
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: location.state.formData
								? location.state.formData.address
								: '',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: '',
							GSTCompanyContactNumber: '',
							GSTCompanyName: '',
							GSTNumber: '',
							GSTCompanyEmail: '',
						},
					],
					Baggage: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Baggage',
							Description: 2,
							Weight: 0,
							Currency: 'INR',
							Price: 5000,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					MealDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Meal',
							Description: 2,
							AirlineDescription: '',
							Quantity: 1,
							Currency: 'INR',
							Price: 300,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					SeatDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							CraftType: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Craft;
										})
								: '',
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
							AvailablityType: 1,
							Description: 2,
							Code: '2A',
							RowNo: '2',
							SeatNo: 'A',
							SeatType: 1,
							SeatWayType: 2,
							Compartment: 1,
							Deck: 1,
							Currency: 'INR',
							Price: 300,
						},
					],
				};
				dispatch(FlightBookDispatch(formData, history, location.state.IDTBO));
			} else if (location.state.body.AdultCount === 2) {
				let formData = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.OneflightData.ResultIndex,
					Passengers: [
						{
							Title: location.state.formData
								? location.state.formData.titleA1
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA1
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA1
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: location.state.formData
								? location.state.formData.address
								: '',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: '',
							GSTCompanyContactNumber: '',
							GSTCompanyName: '',
							GSTNumber: '',
							GSTCompanyEmail: '',
						},
						{
							Title: location.state.formData
								? location.state.formData.titleA2
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA2
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA2
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: location.state.formData
								? location.state.formData.address
								: '',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: '',
							GSTCompanyContactNumber: '',
							GSTCompanyName: '',
							GSTNumber: '',
							GSTCompanyEmail: '',
						},
					],
					Baggage: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Baggage',
							Description: 2,
							Weight: 0,
							Currency: 'INR',
							Price: 5000,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					MealDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Meal',
							Description: 2,
							AirlineDescription: '',
							Quantity: 1,
							Currency: 'INR',
							Price: 300,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					SeatDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							CraftType: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Craft;
										})
								: '',
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
							AvailablityType: 1,
							Description: 2,
							Code: '2A',
							RowNo: '2',
							SeatNo: 'A',
							SeatType: 1,
							SeatWayType: 2,
							Compartment: 1,
							Deck: 1,
							Currency: 'INR',
							Price: 300,
						},
					],
				};
				dispatch(FlightBookDispatch(formData, history, location.state.IDTBO));
			} else if (location.state.body.AdultCount === 3) {
				let formData = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.OneflightData.ResultIndex,
					Passengers: [
						{
							Title: location.state.formData
								? location.state.formData.titleA1
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA1
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA1
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: location.state.formData
								? location.state.formData.address
								: '',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: '',
							GSTCompanyContactNumber: '',
							GSTCompanyName: '',
							GSTNumber: '',
							GSTCompanyEmail: '',
						},
						{
							Title: location.state.formData
								? location.state.formData.titleA2
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA2
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA2
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: location.state.formData
								? location.state.formData.address
								: '',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: '',
							GSTCompanyContactNumber: '',
							GSTCompanyName: '',
							GSTNumber: '',
							GSTCompanyEmail: '',
						},
						{
							Title: location.state.formData
								? location.state.formData.titleA3
								: '',
							FirstName: location.state.formData
								? location.state.formData.first_nameA3
								: '',
							LastName: location.state.formData
								? location.state.formData.last_nameA3
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: location.state.formData
								? location.state.formData.address
								: '',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: '',
							GSTCompanyContactNumber: '',
							GSTCompanyName: '',
							GSTNumber: '',
							GSTCompanyEmail: '',
						},
					],
					Baggage: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Baggage',
							Description: 2,
							Weight: 0,
							Currency: 'INR',
							Price: 5000,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					MealDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Meal',
							Description: 2,
							AirlineDescription: '',
							Quantity: 1,
							Currency: 'INR',
							Price: 300,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					SeatDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							CraftType: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Craft;
										})
								: '',
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
							AvailablityType: 1,
							Description: 2,
							Code: '2A',
							RowNo: '2',
							SeatNo: 'A',
							SeatType: 1,
							SeatWayType: 2,
							Compartment: 1,
							Deck: 1,
							Currency: 'INR',
							Price: 300,
						},
					],
				};
				dispatch(FlightBookDispatch(formData, history, location.state.IDTBO));
			}
		}
	};
	const handleFormSubmit = (data) => {
		console.log(data);
		console.log(
			location.state.OneflightData.AirlineCode
				? Number(Math.round(location.state.OneflightData.Fare.OfferedFare)) *
						Number(100)
				: location.state.OneflightData.Airline_Code
				? Number(
						Math.round(
							location.state.OneflightData.Fares[0].FareDetails[0].Total_Amount
						)
				  ) * Number(100)
				: ''
		);
		if (payment === 'pay') {
			// e.preventDefault();
			var options = {
				key: 'rzp_test_1xufv8E9EKecYL',
				key_secret: 'Ui7h6GeBLYxy1y75QaV6TgBz',
				// amount: location.state.OneflightData.Fare.OfferedFare * 100,
				amount: location.state.OneflightData.AirlineCode
					? Number(Math.round(location.state.OneflightData.Fare.OfferedFare)) *
					  Number(100)
					: location.state.OneflightData.Airline_Code
					? Number(
							Math.round(
								location.state.OneflightData.Fares[0].FareDetails[0]
									.Total_Amount
							)
					  ) * Number(100)
					: '',
				// Number(
				// 	location.state.OneflightData.Airline_Code
				// 		? location.state.OneflightData.Fares[0].FareDetails[0]
				// 				.Total_Amount
				// 		: location.state.OneflightData.AirlineCode
				// 		? location.state.OneflightData.Fare.OfferedFare
				// 		: 5
				// ) * 100,
				currency: 'INR',
				name: 'Musafir Bazar',
				description: 'for testing purpose',
				handler: handlePayment,
				prefill: {
					name: `${location.state.formData.first_name} ${location.state.formData.last_name}`,
					email: location.state.formData.email,
					contact: location.state.formData.phone,
				},
				notes: {
					address: location.state.formData.address,
				},
				theme: {
					color: '#3399cc',
				},
			};
			var pay = new window.Razorpay(options);
			pay.open();
		}
	};
	const handleHold = (e) => {
		if (e.target.value === 'hold') {
			dispatch(setPayment(e.target.value));
			if (hold) {
				setPay(false);
				setOffline(false);
				setHold(false);
			} else {
				setHold(true);
				setPay(false);
				setOffline(false);
			}
		} else if (e.target.value === 'pay') {
			dispatch(setPayment(e.target.value));
			if (pay) {
				setPay(false);
				setOffline(false);
				setHold(false);
			} else {
				setPay(true);
				setHold(false);
				setOffline(false);
			}
		} else if (e.target.value === 'offline') {
			dispatch(setPayment(e.target.value));
			if (offline) {
				setPay(false);
				setHold(false);
				setOffline(false);
			} else {
				setPay(false);
				setHold(false);
				setOffline(true);
			}
		}
		console.log(e.target.value);
	};
	const edit = () => {
		history.push({
			pathname: '/summaryflight',
			state: {
				formData: location.state.formData,
				body: location.state.body,
				OneflightData: location.state.OneflightData,
			},
		});
	};
	return (
		<>
			<Formik
				initialValues={{
					email: location.state.formData.email,
					phone: location.state.formData.phone,
					titleA1: location.state.formData.titleA1,
					first_nameA1: location.state.formData.first_nameA1,
					last_nameA1: location.state.formData.last_nameA1,
					titleA2: location.state.formData.titleA2,
					first_nameA2: location.state.formData.first_nameA2,
					last_nameA2: location.state.formData.last_nameA2,
					titleA3: location.state.formData.titleA3,
					first_nameA3: location.state.formData.first_nameA3,
					last_nameA3: location.state.formData.last_nameA3,
					titleA4: location.state.formData.titleA4,
					first_nameA4: location.state.formData.first_nameA4,
					last_nameA4: location.state.formData.last_nameA4,
					titleA5: location.state.formData.titleA5,
					first_nameA5: location.state.formData.first_nameA5,
					last_nameA5: location.state.formData.last_nameA5,
					titleA6: location.state.formData.titleA6,
					first_nameA6: location.state.formData.first_nameA6,
					last_nameA6: location.state.formData.last_nameA6,
					titleA7: location.state.formData.titleA7,
					first_nameA7: location.state.formData.first_nameA7,
					last_nameA7: location.state.formData.last_nameA7,
					titleA8: location.state.formData.titleA8,
					first_nameA8: location.state.formData.first_nameA8,
					last_nameA8: location.state.formData.last_nameA8,
					titleC1: location.state.formData.titleC1,
					first_nameC1: location.state.formData.first_nameC1,
					last_nameC1: location.state.formData.last_nameC1,
					titleC2: location.state.formData.titleC2,
					first_nameC2: location.state.formData.first_nameC2,
					last_nameC2: location.state.formData.last_nameC2,
					titleC3: location.state.formData.titleC3,
					first_nameC3: location.state.formData.first_nameC3,
					last_nameC3: location.state.formData.last_nameC3,
					titleC4: location.state.formData.titleC4,
					first_nameC4: location.state.formData.first_nameC4,
					last_nameC4: location.state.formData.last_nameC4,
					titleC5: location.state.formData.titleC5,
					first_nameC5: location.state.formData.first_nameC5,
					last_nameC5: location.state.formData.last_nameC5,
					titleC6: location.state.formData.titleC6,
					first_nameC6: location.state.formData.first_nameC6,
					last_nameC6: location.state.formData.last_nameC6,
				}}
				validate={(values) => {
					const errors = {};

					return errors;
				}}
				onSubmit={handleFormSubmit}>
				{({ submitForm, isSubmitting, values, errors }) => (
					<>
						{' '}
						<Form>
							{/* Email and PhoneNumber Section */}
							<Box
								className={classes.root}
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '5px',
								}}>
								<Grid
									container
									spacing={2}
									alignItems='center'
									style={{ marginTop: 20, alignItems: 'baseline' }}>
									<Grid item xs={12} lg={6}>
										<Field
											component={TextField}
											name='email'
											type='email'
											disabled
											variant='outlined'
											label='Email ID'
											className={classes.selectField}
											InputProps={{
												className: classes.InputPropsStyle,
											}}
											inputProps={{
												style: { padding: 12 },
											}}
										/>
									</Grid>
									<Grid item xs={12} lg={6}>
										<Field
											component={TextField}
											name='phone'
											type='number'
											disabled
											variant='outlined'
											error={errors.phone}
											label='Mobile No.'
											className={classes.selectField}
											InputProps={{
												className: classes.InputPropsStyle,
											}}
											inputProps={{
												style: { padding: 12 },
											}}
										/>
									</Grid>
								</Grid>
							</Box>
							{/* for adult 1 */}
							{location.state.body.AdultCount === 1 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											1
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												variant='outlined'
												disabled
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for adult 2 */}
							{location.state.body.AdultCount === 2 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											2
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												variant='outlined'
												disabled
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for adult 3 */}
							{location.state.body.AdultCount === 3 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											3
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												variant='outlined'
												disabled
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA3'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA3'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA3'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for adult 4 */}
							{location.state.body.AdultCount === 4 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											3
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA3'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA3'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA3'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA4'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA4'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA4'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for adult 5 */}
							{location.state.body.AdultCount === 5 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											5
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA3'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA3'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA3'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA4'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA4'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA4'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA5'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA5}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA5'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA5'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for adult 6 */}
							{location.state.body.AdultCount === 6 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											6
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA3'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA3'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA3'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA4'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA4'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA4'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA5'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA5}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA5'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA5'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA6'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA6}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA6'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA6'
												type='text'
												variant='outlined'
												disabled
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for adult 7 */}
							{location.state.body.AdultCount === 7 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											7
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA3'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA3'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA3'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA4'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA4'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA4'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA5'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA5}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA5'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA5'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA6'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA6}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA6'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA6'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA7'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA6}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA7'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA7'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for adult 8 */}
							{location.state.body.AdultCount === 8 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											8
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA3'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA3'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA3'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA4'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA4'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA4'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA5'
												type='text'
												variant='outlined'
												label='Select Title'
												disabled
												error={errors.titleA5}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA5'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA5'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA6'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA6}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA6'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA6'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA7'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA7}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA7'
												type='text'
												variant='outlined'
												disabled
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA7'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA8'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA8}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA8'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA8'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for adult 9 */}
							{location.state.body.AdultCount === 9 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											9
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA3'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA3'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA3'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA4'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA4'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA4'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA5'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA5}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA5'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA5'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA6'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA6}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA6'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA6'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA7'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleA7}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA7'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA7'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA8'
												type='text'
												variant='outlined'
												disabled
												label='Select Title'
												error={errors.titleA8}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA8'
												type='text'
												variant='outlined'
												disabled
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA8'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA9'
												disabled
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA9}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA9'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA9'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for ChildCount 1 */}
							{location.state.body.ChildCount === 1 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											1
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Child
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC1'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC1'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC1'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for ChildCount 2 */}
							{location.state.body.ChildCount === 2 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											2
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Child
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC1'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC1'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC1'
												type='text'
												variant='outlined'
												disabled
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC2'
												type='text'
												variant='outlined'
												disabled
												label='Select Title'
												error={errors.titleC2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC2'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC2'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for Child 3 */}
							{location.state.body.ChildCount === 3 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											3
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Child
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC1'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC1'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC1'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC2'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC2'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC2'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC3'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC3'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC3'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for Child 4 */}
							{location.state.body.ChildCount === 4 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											4
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Child
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC1'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC1'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC1'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC2'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC2'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC2'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC3'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC3'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC3'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC4'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC4'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC4'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for Child 5 */}
							{location.state.body.ChildCount === 5 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											5
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Child
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC1'
												type='text'
												variant='outlined'
												disabled
												label='Select Title'
												error={errors.titleC1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC1'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC1'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC2'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC2'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC2'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC3'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC3'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC3'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC4'
												disabled
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC4'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC4'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC5'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC5}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC5'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC5'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for Child 6 */}
							{location.state.body.ChildCount === 6 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											6
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Child
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC1'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC1'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC1'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC2'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC2'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC2'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC3'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC3'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC3'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC4'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC4'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC4'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC5'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC5}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC5'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC5'
												type='text'
												disabled
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC6'
												type='text'
												disabled
												variant='outlined'
												label='Select Title'
												error={errors.titleC6}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC6'
												type='text'
												disabled
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC6'
												type='text'
												variant='outlined'
												disabled
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* payment method */}
							<Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '5px',
								}}>
								{agentlogin &&
								agentlogin.result &&
								agentlogin.result.result &&
								agentlogin.result.result.role === 'Agent' ? (
									<>
										<FormControlLabel
											value='offline'
											control={<Radio checked={offline} onClick={handleHold} />}
											label='Offline Amount 8000'
										/>
										<FormControlLabel
											value='hold'
											control={<Radio checked={hold} onClick={handleHold} />}
											label='Hold'
										/>
									</>
								) : (
									''
								)}

								<FormControlLabel
									value='pay'
									control={<Radio checked={pay} onClick={handleHold} />}
									label='Pay Online'
								/>
							</Box>
							{/* Submit and Edit Button */}
							<Grid container spacing={2}>
								<Grid item xs={2}>
									<Button
										className={classes.createButton}
										onClick={edit}
										style={{ marginTop: 10, fontSize: 14 }}
										// disabled={isSubmitting}
									>
										EDIT
									</Button>
								</Grid>
								<Grid item xs={4}>
									<Button
										className={classes.createButton}
										onClick={handleFormSubmit}
										style={{ marginTop: 10, fontSize: 14 }}
										// disabled={isSubmitting}
									>
										PROCESS TO PAYMENT
									</Button>
								</Grid>
								<Grid item xs={4}></Grid>
							</Grid>
						</Form>
					</>
				)}
			</Formik>
			<ErrorModal />
		</>
	);
};

export default FlightConfirmForm;
